import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import {
    isValidNameWithSpace,
    renderCheckBox,
    renderTextField,
} from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import validate from './validate';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import { checkFieldExistenceInMasterDB } from '../../../../../modules/AppConfig/actions'; 

import { saveDatabase } from '../actions/ManageDataBaseAction';
import { MODULE } from '../constants/ApiConstants';


class ManageDatabaseModal extends Component {
        constructor(props) {
            super(props);
            this.state = {
                open: true,
                database_Data: props.database_Data,
                database_Id: props.database_Data ? props.database_Data.databaseDetailID : null
            };
            //  console.log("id -------------", this.props.database_Data);
        }

        componentWillReceiveProps(nextProps) {
            let self = this;
            document.onkeydown = function (evt) {
                evt = evt || window.event;
                if (evt.keyCode === 27) {
                    self.handleClose();
                }
            };
        }

        handleClose = () => {
            if (this.state.open) {
                this.setState({ open: false });
                this.props.closeDialog();
            }
        };

        onSubmitHandler(formData) {

            formData.databaseDetailID = this.state.database_Id;
            // console.log("form data-----------------", formData);
            this.props.saveDatabase(formData);
            this.handleClose();
        }

        /** *******************     Input field exist check        ***********************/
        checkFieldDataExistence = (input, value, labelName) => {
            if (value.length > 0) {
                let postData = {
                    'labelName': labelName,
                    'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
                    'value': value,
                    'colmnName': input.target.name.toUpperCase(),
                    'id': (this.props.initialValues && this.props.initialValues.Id) ? this.props.initialValues.Id : 0,
                };
                this.props.checkFieldExistenceInMasterDB(postData);
            }
        };
        /** *****   End Input field exist check    **********/

        render() {
            const { handleSubmit } = this.props;
            let submitButton = this.props.loading ?
                <SubmitButtonModalDisabled label="Loading" /> :
                <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
            const actions = [
                <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
                submitButton,
            ];
            return (
                <Dialog className="custom_modal"
                    title={this.props.database_Data ? 'Edit Database' : 'Add Database'}
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}>

                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 require">
                                        <Field
                                            autoFocus={true}
                                            name="databaseName"
                                            type="text"
                                            maxLength='50'
                                            label="Database Name"
                                            onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Database Name')}
                                            customError={displayCustomError('DATABASENAME', this.props.fieldError)}
                                            normalize={isValidNameWithSpace}
                                            component={renderTextField} />

                                    </div>
                                    <div className="col-sm-12 col-md-6 require">
                                        <Field
                                            name="serverName"
                                            label="Server Name"
                                            maxLength="50"
                                            component={renderTextField}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 require">
                                        <Field
                                            name="userName"
                                            type="text"
                                            maxLength="50"
                                            label="User Name"
                                            component={renderTextField}
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-6 require">
                                        <Field
                                            name="password"
                                            label="Password"
                                            type="password"
                                            maxLength="50"                                            
                                            component={renderTextField}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 col-md-6 require">
                                        <Field
                                            name="confirmPassword"
                                            maxLength="50"
                                            type="password"                                            
                                            label="Confirm Password"
                                            component={renderTextField}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <Field className="mt20 mb0"
                                            name="isCentralised"
                                            label="Centralized Database"
                                            component={renderCheckBox}
                                        />
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </Dialog>
            );
        }
    }

function mapStateToProps(state, ownProps) {
    return {
        initialValues: ownProps.database_Data ? {
            databaseName: ownProps.database_Data.databaseName,
            serverName: ownProps.database_Data.serverName,
            userName: ownProps.database_Data.userName,
            password: ownProps.database_Data.password,
            confirmPassword: ownProps.database_Data.password,
            isCentralised: ownProps.database_Data.isCentralised,
            Id: ownProps.database_Data.databaseDetailID
        } : {},
        fieldError: state.appConfig.fieldError,
    };
};

ManageDatabaseModal = reduxForm({
    form: 'ManageDatabaseModalForm',
    validate,
    enableReinitialize: true,
})(ManageDatabaseModal);

export default connect(mapStateToProps, { saveDatabase, checkFieldExistenceInMasterDB })(ManageDatabaseModal);


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/components/ManageDataBaseModal.js